import axios from 'axios';
import { env } from '@/lib/env';
import type { AuthMode } from '@/lib/storage';

export interface TokenPair {
  access: string;
  refresh: string;
}

/**
 * Advertiser login — vendor credentials via /vendor/login (returns SimpleJWT
 * pair for role=vendor users). Team login — staff/admin via /auth/api/token/.
 * Bare axios so it works before the app-wide client has a token.
 */
export async function login(mode: AuthMode, username: string, password: string): Promise<TokenPair> {
  const url = mode === 'team' ? `${env.apiBase}/auth/api/token/` : `${env.apiBase}/vendor/login`;
  const res = await axios.post(url, { username, password }, { headers: { 'Content-Type': 'application/json' } });
  const data = res.data || {};
  if (!data.access || !data.refresh) {
    const msg = data.message || 'Login failed. Check your credentials.';
    throw new Error(msg);
  }
  return { access: data.access, refresh: data.refresh };
}

export async function refreshAccess(mode: AuthMode, refresh: string): Promise<TokenPair> {
  const url = mode === 'team' ? `${env.apiBase}/auth/verify-otp/refresh` : `${env.apiBase}/vendor/refresh`;
  const res = await axios.post(url, { refresh }, { headers: { 'Content-Type': 'application/json' } });
  return { access: res.data?.access, refresh: res.data?.refresh || refresh };
}
